import { ValidationService } from 'aspnet-client-validation';

export class CustomValidationService {
    private validationService: ValidationService;

    constructor() {
        this.validationService = new ValidationService();
    }

    public initialize(): void {
        this.validationService.bootstrap();
        this.setupCustomProviders();
    }

    private setupCustomProviders(): void {
        this.setupMinimumAgeProvider();
        this.setupRequiredIfProvider();
        this.setupCombinedMaxLengthProvider();
    }

    // Mirrors CombinedMaxLengthAttribute: this field's length plus another field's
    // length must stay within a shared limit (e.g. first + last name).
    private setupCombinedMaxLengthProvider(): void {
        this.validationService.addProvider('combinedmaxlength', (value, _element, params) => {
            const limit = parseInt(params['combinedlength']);
            if (isNaN(limit)) {
                return true;
            }

            const other = document.querySelector<HTMLInputElement>('#' + params['otherproperty']);
            const otherLength = other?.value.trim().length ?? 0;

            return (value ?? '').trim().length + otherLength <= limit;
        });
    }

    private setupMinimumAgeProvider(): void {
        this.validationService.addProvider('minimumage', (value, _element, params) => {
            let date = new Date(value);
            let today = new Date();

            let minimumAge = parseInt(params['age']) ?? 18;
            let age = today.getFullYear() - date.getFullYear();
            let monthDiff = today.getMonth() - date.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                age--;
            }

            return age >= minimumAge;
        });
    }

    private setupRequiredIfProvider(): void {
        this.validationService.addProvider('requiredif', (value, _, params) => {
            var targetId = params.otherproperty;
            var targetValue = params.otherpropertyvalue;

            var otherPropertyValue = (targetValue == null || targetValue == undefined ? "" : targetValue).toString();

            var otherPropertyElement = document.querySelector('#' + targetId) as HTMLInputElement;

            // Radio button groups: individual buttons have custom IDs, so querySelector by ID
            // may return null or match a single radio button. In either case, find the checked
            // radio by name and compare its value instead of using the .checked boolean.
            if (!otherPropertyElement || otherPropertyElement.type === 'radio') {
                var checkedRadio = document.querySelector('input[name="' + targetId + '"]:checked') as HTMLInputElement;
                if (!checkedRadio) {
                    return true;
                }
                var isRequired = checkedRadio.value.toLowerCase() === otherPropertyValue.toLowerCase();
                return isRequired ? value !== '' : true;
            }

            // Checkbox / hidden field: compare the checked boolean as a string ("true"/"false")
            if (otherPropertyElement.checked.toString() === otherPropertyValue.toLowerCase()) {
                return value !== '';
            }

            return true;
        });
    }
}
